module.exports = "https://p.cds.unp.clasificados.pe/aristotelica-regular.b69e3b78d0ba360e28a31ae4689ba804.woff2";